import React from 'react';
import styled from 'styled-components';
import { useDeviceType } from '@hotelplan/libs.context.device-type';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import { WishlistViewType } from 'fdr/components/local/fdr-wishlist/fdr-wishlist.constants';
import FdrWishlistMapAccess from './fdr-wishlist-map-access';

const WishlistFooterMapAccessWrapper = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    mx: [-4, 'auto'],
    width: ['auto', '100%'],
    height: ['500px', 'auto'],
  })
);

const FdrWishlistFooterMapAccess: React.FC<{ type: WishlistViewType }> = ({
  type,
}) => {
  const { mobile } = useDeviceType();

  // NOTE: The map should be shown in the sidebar on the List view desktop.
  if (!mobile && type === WishlistViewType.List) return null;

  return (
    <WishlistFooterMapAccessWrapper>
      <FdrWishlistMapAccess forceMapPreview />
    </WishlistFooterMapAccessWrapper>
  );
};

export default FdrWishlistFooterMapAccess;
